'use strict';

function PerformanceReviewIntroController(performanceReviewService) {
  var vm = this;

  vm.$onInit = $onInit;

  function $onInit() {
    vm.url = vm.data.is_lockable ? performanceReviewService.urls.questionnaire.base({ token: vm.data.token}) : performanceReviewService.urls.questionnaire.step({ token: vm.data.token, step: 1 });
  }
}

module.exports = PerformanceReviewIntroController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-intro/performance-review-intro.controller.js
 ** module id = 308
 ** module chunks = 0
 **/